var _stop, _stop2, _circle, _g, _path, _ellipse, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgAddMediaIcon(props) {
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480.12 452.28"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: -1658.69,
    y1: 397.64,
    x2: -1658.69,
    y2: 396.3,
    gradientTransform: "matrix(93.51 0 0 -187.61 155221.33 74739.85)",
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03a7fd"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4600dc"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id2,
    transform: "translate(-.03)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 221.37,
    cy: 238.45,
    r: 221.37,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 25-2-2",
    cx: 226.12,
    cy: 230.91,
    r: 221.37,
    fill: "#dcdede"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M169 231.51a121.83 121.83 0 0015.05-171.64c-.7-.84-1.41-1.66-2.13-2.48A125.86 125.86 0 00132.11 23a26.71 26.71 0 01-10.48 12.36C113.23 41 104.93 46.82 96.85 53a229.48 229.48 0 00-37.33 36.07c-8.45 11.43-19.89 24.49-25.61 37.49-7.18 17.66-15.64 35.74-18.5 54.59-4.78 17-9.52 34.58-7.67 50.54 3.49 23.32 9.53 58.09 18.5 79.86 5 11.66 12.23 28.88 14.89 32.49 10.38 14 19.32 20.41 26.18 30.68s16.54 12.14 23.91 22.11c3.8 5.14 15.16 6.73 18.8 12 2.32 3.33 4.4 6.76 6.38 10.27l.22.06a50.67 50.67 0 0127 16.53A122.26 122.26 0 00169 231.51z",
    transform: "translate(-.03)",
    fill: "url(#".concat(_id, ")")
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M84.74 62c-.86 0-1.72 0-2.58.05a18.4 18.4 0 01-5.52 4.91 175 175 0 00-24.16 25.25 195 195 0 00-15.25 23.46c-2.42 4.43-4.64 9-7.08 13.37-2.09 3.78-4.06 7.6-5.87 11.52a129.23 129.23 0 00-5.67 21.7c-.45 2.47-1 5-1.59 7.4A75.14 75.14 0 1084.74 62z",
    fill: "#fbfbfb"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.23,
    cy: 155.03,
    rx: 24.95,
    ry: 24.48,
    fill: "#1d1d1b"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 134",
    d: "M-.03 225.58C-.03 101 100.97 0 225.6 0s225.59 101 225.58 225.61-101 225.58-225.61 225.57S-.03 350.19-.03 225.61zm226-216.17C106.11 9.4 8.88 106.61 8.87 226.54s97.21 217.15 217.1 217.16 217.19-97.21 217.2-217.13c-.01-119.94-97.2-217.15-217.14-217.16z",
    fill: "#1253fa"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1",
    clipPath: "url(#".concat(_id2, ")")
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 132",
    d: "M322.85 214l-1.62 31.77 141.53 16.33 1.61-31.77z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2",
    fill: "#fff",
    d: "M334.424 174.593l10.578-26.314 131.493 52.86-10.578 26.314z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 133",
    d: "M330.73 176.14l12.68-31.55 136.71 55-12.69 31.55zm14.24-27.88l-10.58 26.31 131.46 52.87 10.58-26.31z",
    fill: "#1253fa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 134-2",
    d: "M321.97 211.15l146.28 17.35-12 101.69-146.37-17.34zM465.11 231L324.4 214.29l-11.38 96.08 140.7 16.68z",
    fill: "#1253fa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 135",
    d: "M363.02 153.38l4.53 35.92-6.48-2-5.36-1.61-4.52-35.83z",
    fill: "#1253fa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 136",
    d: "M402.39 204.59l-2.92-.88-4.62-36.62 7.84 2.38 4 1.2 4.62 36.65c-2.97-.93-5.94-1.83-8.92-2.73z",
    fill: "#1253fa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 137",
    d: "M447.97 221.85l-3.89-1.16-4.49-35.76q4.79 1.47 9.58 2.91l2.27.66 4.5 35.72z",
    fill: "#1253fa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3",
    fill: "#1253fa",
    d: "M311.458 311.618l7.868-66.375 143.515 17.011-7.868 66.376z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 138",
    d: "M445.24 227.33l12.82 1.67-21.64 29.56-5.3-.62-7.64-.83z",
    fill: "#1253fa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 139",
    d: "M376.59 251.43l21.89-29.91 10.67 1.29 2.2.26L389.48 253c-4.2-.55-8.79-1.09-12.89-1.57z",
    fill: "#1253fa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 140",
    d: "M338.52 247.41c-3.46-.41-6.91-.81-10.37-1.2l22.24-30.39 9.63 1.16 3.25.39-22.2 30.35z",
    fill: "#1253fa"
  }))))))));
}
export default SvgAddMediaIcon;